import React from "react";

import * as sass from "./index.module.scss";

const Layout = ({ children }) => {
    return (
        <main>
            {children}
        </main>
    );
}

export default Layout;